export default "__VITE_ASSET__BrfJ_HcM__"